export const formatErrorMessages = (errors) => {
  if (!errors || typeof errors !== "object") {
    return "An unknown error occurred";
  }
  return Object.values(errors).flat().join(", ");
};
